import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'translateAttribute',
  pure: false
})
export class TranslateAttributePipe implements PipeTransform {
  private langChangeSubscription: Subscription;

  constructor(
    private translocoService: TranslocoService,
    private cdr: ChangeDetectorRef
  ) {
    this.langChangeSubscription = this.translocoService.langChanges$.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  transform(value: any): string {
    if (!value) {
      return '';
    }

    let parsedValue: any;

    if (typeof value === 'string') {
      try {
        parsedValue = JSON.parse(value);
      } catch (error) {
        // console.warn('TranslateAttributePipe: Failed to parse value as JSON', value);
        return value;
      }
    } else if (typeof value === 'object') {
      parsedValue = value;
    } else {
      return value;
    }

    const currentLang = this.translocoService.getActiveLang();

    return parsedValue[currentLang] || parsedValue['en'] || '';
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }
}
